export const num2name = {
    0: "ERROR_UNSPECIFIED",
    1: "ERROR_INVALID_SUBSCRIPTION_PRODUCT_BOARD_TEMPLATE",
};
export const name2num = {
    ERROR_UNSPECIFIED: 0,
    ERROR_INVALID_SUBSCRIPTION_PRODUCT_BOARD_TEMPLATE: 1,
};
